const qos = {
    frontDelay: 0,
    rearDelay: 0,
    audioDelay: 0,
    freezeRate: 0,
    renderFrameRate: 0,
};

const rtc = {
    client: null,
    localAudioTrack: null,
    localVideoTrack: null,
};

const rtm = {
    client: null,
    peerId: ''
};

const localTracks = {
    audioTrack: null
};

const V4 = {
    "speed1": [
        0.2,
        4.0,
        0.0
    ],
    "speed2": [
        0.3,
        2.5,
        0.0
    ],
    "speed3": [
        0.45,
        0.6,
        0.0
    ],
    "speed4": [
        0.6,
        0.25,
        0.0
    ],
    "speed5": [
        0.7,
        0.2,
        0.0
    ]
}
const V5 = { "speed1": [0.3, 2.0, 0.0], "speed2": [0.5, 1.0, 0.0], "speed3": [0.7, 0.5, 0.0], "speed4": [0.85, 0.4, 0.0], "speed5": [1.0, 0.4, 0.0] }

const frontCamMediaStream = typeof window !== 'undefined' ? new window.MediaStream() : '';
const backCamMediaStream = typeof window !== 'undefined' ? new window.MediaStream() : '';
const microphoneMediaStream = typeof window !== 'undefined' ? new window.MediaStream() : '';

const frontCamMediaMenuStream = [];
const backCamMediaMenuStream = [];
const microphoneMediaMenuStream = [];
const menuStreamIndexNumber = 0;

const checkAngularLevel = (controlConfig, linear) => {

    let normal = controlConfig.speed3[0];

    let lower = controlConfig.speed2[0];
    let lowest = controlConfig.speed1[0];

    let faster = controlConfig.speed4[0];
    let fastest = controlConfig.speed5[0];

    if (linear >= (fastest + faster) / 2.0) {
        //console.log('fastest');
        return controlConfig.speed5[1];
    }
    else if (linear >= (faster + normal) / 2.0) {
        //console.log('faster');
        return controlConfig.speed4[1];
    }
    else if (linear >= (normal + lower) / 2.0) {
        //console.log('normal');
        return controlConfig.speed3[1];
    }
    else if (linear >= (lower + lowest) / 2.0) {
        //console.log('lower');
        return controlConfig.speed2[1];
    }
    else {
        //console.log('lowest');
        return controlConfig.speed1[1];
    }
}

export { frontCamMediaMenuStream, backCamMediaMenuStream, microphoneMediaMenuStream, menuStreamIndexNumber, qos, rtc, rtm , localTracks, V4, V5, frontCamMediaStream, backCamMediaStream, microphoneMediaStream, checkAngularLevel }
